import { useCallback, useState } from 'react';
import { toggleBar } from './toggleToolbar';
import { setStartPoint } from './setStartPoint';

export const SPEECH_STREAM_START_POINT_ID = 'speechstream-start-point';

export const useSpeechStreamToolbar = (startPointId?: string) => {
  const [loading, setLoading] = useState(false);

  const loadToolbar = useCallback(async () => {
    if (window.speechstream.domControlTools) {
      return toggleBar();
    }
    setLoading(true);
    try {
      await window.speechstream.Loader.lateLoad();
      if (startPointId) {
        setStartPoint(document.getElementById(startPointId));
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  }, [startPointId]);

  return { loadToolbar, loading };
};
